import {
    ChangeDetectionStrategy,
    Component,
    OnInit,
} from '@angular/core';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { ILog } from '@models';

@Component({
    templateUrl: './log-details.modal.html',
    styleUrls: ['./log-details.modal.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogDetailsModalComponent
    extends UiModalComponent<ILog>
    implements OnInit {
    public rawMessage: any;

    ngOnInit() {
        this.rawMessage = JSON.parse(this.context.data.rawMessage);
    }
}
